import React from 'react'
import { Link } from 'react-router-dom'
import { Image } from '../../../../../AbstractElements'
import { dynamicImage } from '../../../../../Utils'
import { LoginFormProp } from '../../../../../Types/Others.type' // Import the prop type

const CommonLogo: React.FC<LoginFormProp> = ({ logoClass }) => {
    return (
        <Link className={`logo ${logoClass}`} to={`${process.env.PUBLIC_URL}/dashboard/default`} style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <Image className="img-fluid for-dark" src={dynamicImage('logo/smallLogo.png')} alt="loginpage" />
            <Image className="img-fluid for-light" src={dynamicImage('logo/smallLogo.png')} alt="loginpage" />
            <h1 style={{ fontFamily: 'Arial, sans-serif', fontWeight: 'bold', color: '#000', margin: 0 }}>
    <span style={{ fontSize: '30px', display: 'inline-block' }}>
        Travancore<sup style={{ fontSize: '12px', fontWeight: 'normal' }}>™</sup>
    </span>
    <br />
    <span style={{ fontSize: '30px', fontWeight: 'normal', display: 'inline-block', marginLeft: '-40px' }}>
        Medicity
    </span>
</h1>

</Link>
    )
}

export default CommonLogo


